import { theme } from 'antd';
import React from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';
import OverflowTooltip from './OverflowTooltip';

function Link(props: LinkProps) {
  const { token } = theme.useToken();
  const { to, children, ...rest } = props;
  let link;

  if (typeof to === 'string' && !to.startsWith('/')) {
    link = (handleMouseEnter?: any) => (
      <a
        href={to}
        rel="noopener noreferrer"
        target="_blank"
        onMouseEnter={handleMouseEnter}
        style={{ color: token.colorPrimary }}
      >
        {children}
      </a>
    );
  }
  else {
    link = (handleMouseEnter?: any) => (
      <RouterLink
        to={to}
        {...rest}
        onMouseEnter={handleMouseEnter}
        style={{ color: token.colorPrimary }}
      >
        {children}
      </RouterLink>
    );
  }

  if (typeof children === 'string')
    return <OverflowTooltip title={children}>{link}</OverflowTooltip>;
  return link();
}

export default Link;
